import script from "./OrganizationLogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationLogs.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationLogs.vue?vue&type=style&index=0&id=048ec144&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048ec144"]])

export default __exports__